import React from "react";
import { Spin } from "antd";

/**
 * Sprint 98 — route-level code-splitting fallback.
 *
 * Rendered by the single <Suspense> boundary in App.tsx while a lazily-loaded
 * vertical (medTech, reportGenerator, fin_auditor, tenant-management, triage,
 * payment, scheduler) downloads its chunk.
 *
 * Deliberately lightweight: a centered AntD <Spin>. <Spin> consumes the nearest
 * <ConfigProvider> theme (App.tsx wraps everything in one), so the spinner picks
 * up the active palette — Atrium blue when the flag is on, the legacy primary
 * otherwise — with no hard-coded colours here.
 */
export default function RouteFallback() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <Spin size="large" tip="Loading…">
        <div style={{ padding: 24 }} />
      </Spin>
    </div>
  );
}
